export default [
  {
    path: '/dmas',
    name: 'dmas',
    component: () => import('../../views/dmas/dmas.vue'),
    meta: {
      pageTitle: 'DMAs',
      breadcrumbs: ['DMAs'],
    },
    children: [
      {
        path: '',
        name: 'dmas-list',
        component: () => import('../../views/dmas/list.vue')
      },
      {
        path: 'create',
        name: 'dmas-create',
        component: () => import('../../views/dmas/create.vue'),
        meta: {
          pageTitle: 'Create DMA',
          breadcrumbs: ['Locations', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'dmas-edit',
        component: () => import('../../views/dmas/edit.vue'),
        meta: {
          pageTitle: 'Edit DMA',
          breadcrumbs: ['Locations', 'Edit'],
        }
      },
    ]
  }
]
